import React from "react";

const PALETTE = [
  "bg-brand-500",
  "bg-indigo-500",
  "bg-teal-500",
  "bg-orange-500",
  "bg-pink-500",
  "bg-cyan-600",
];

const getInitials = (name = "") => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
};

const getColorIndex = (seed = "") =>
  Math.abs([...seed].reduce((sum, char) => sum + char.charCodeAt(0), 0)) % PALETTE.length;

const AvatarInitials = ({ name, size = "h-10 w-10", className = "" }) => (
  <span
    className={`flex ${size} shrink-0 items-center justify-center rounded-full text-sm font-bold text-white ${
      PALETTE[getColorIndex(name)]
    } ${className}`}
  >
    {getInitials(name)}
  </span>
);

export default AvatarInitials;
